export const oncekiIndirimlerData = [
    {key: 'evet', text: 'EVET', value: 'EVET'},
    {key: 'hayır', text: 'HAYIR', value: 'HAYIR'},
    {key: 'hayır (d)', text: 'HAYIR (D)', value: 'HAYIR (D)'},

];